var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgScheduling = function SvgScheduling(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-7 {\n        fill: url(#linear-gradient-9);\n      }\n\n      .cls-8 {\n        fill: url(#linear-gradient-8);\n      }\n\n      .cls-9 {\n        fill: url(#linear-gradient-10);\n      }\n\n      .cls-10 {\n        fill: url(#linear-gradient-4);\n      }"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 5.81,
    y1: 175.61,
    x2: 158.28,
    y2: 40.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a70095"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -34.3,
    y1: 130.49,
    x2: 118.17,
    y2: -5.03,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -19.08,
    y1: 147.62,
    x2: 133.39,
    y2: 12.09,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -3.86,
    y1: 164.74,
    x2: 148.61,
    y2: 29.21,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -20.6,
    y1: 145.91,
    x2: 131.87,
    y2: 10.38,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -5.38,
    y1: 163.03,
    x2: 147.09,
    y2: 27.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -6.9,
    y1: 161.32,
    x2: 145.57,
    y2: 25.79,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 8.32,
    y1: 178.44,
    x2: 160.79,
    y2: 42.91,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 46.95,
    y1: 221.89,
    x2: 199.42,
    y2: 86.37,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 44.85,
    y1: 219.53,
    x2: 197.32,
    y2: 84,
    xlinkHref: "#linear-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M199.95,135.64c-.88-22.17-14.21-41.94-34.43-51.07V24.14c0-5.71-4.63-10.34-10.34-10.34h-10.34c0-5.71-4.63-10.34-10.34-10.34s-10.34,4.63-10.34,10.34h-13.79c0-5.71-4.63-10.34-10.34-10.34s-10.34,4.63-10.34,10.34h-13.79c0-5.71-4.63-10.34-10.34-10.34s-10.34,4.63-10.34,10.34h-13.79c0-5.71-4.63-10.34-10.34-10.34s-10.34,4.63-10.34,10.34h-10.34C4.63,13.8,0,18.43,0,24.14v144.83c0,1.9,1.54,3.45,3.45,3.45h10.34v10.34c0,1.9,1.54,3.45,3.45,3.45h90.8s.08-.02.12-.02c18.26,12.6,42.08,13.79,61.51,3.09,19.44-10.7,31.15-31.47,30.27-53.64ZM131.04,13.8c0-1.9,1.54-3.45,3.45-3.45s3.45,1.54,3.45,3.45v10.34h-6.9v-10.34ZM96.55,13.8c0-1.9,1.54-3.45,3.45-3.45s3.45,1.54,3.45,3.45v10.34h-6.9v-10.34ZM62.07,13.8c0-1.9,1.54-3.45,3.45-3.45s3.45,1.54,3.45,3.45v10.34h-6.9v-10.34ZM27.59,13.8c0-1.9,1.54-3.45,3.45-3.45s3.45,1.54,3.45,3.45v10.34h-6.9v-10.34ZM6.9,24.14c0-1.9,1.54-3.45,3.45-3.45h10.34v6.9c0,1.9,1.54,3.45,3.45,3.45h13.79c1.9,0,3.45-1.54,3.45-3.45v-6.9h13.79v6.9c0,1.9,1.54,3.45,3.45,3.45h13.79c1.9,0,3.45-1.54,3.45-3.45v-6.9h13.79v6.9c0,1.9,1.54,3.45,3.45,3.45h13.79c1.9,0,3.45-1.54,3.45-3.45v-6.9h13.79v6.9c0,1.9,1.54,3.45,3.45,3.45h13.79c1.9,0,3.45-1.54,3.45-3.45v-6.9h10.34c1.9,0,3.45,1.54,3.45,3.45v17.24H6.9v-17.24ZM6.9,165.52V48.28h151.73v33.63c-5.58-1.72-11.4-2.6-17.24-2.6-20.6-.01-39.69,10.79-50.28,28.45-10.59,17.66-11.13,39.59-1.42,57.75H6.9ZM20.69,179.32v-6.9h73.39c1.76,2.44,3.71,4.75,5.82,6.9H20.69ZM141.38,189.66c-28.57,0-51.72-23.16-51.72-51.72s23.16-51.72,51.72-51.72c28.55.03,51.69,23.17,51.72,51.72,0,28.57-23.16,51.72-51.72,51.72Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M31.03,62.07c-5.71,0-10.34,4.63-10.34,10.34s4.63,10.34,10.34,10.34,10.34-4.63,10.34-10.34-4.63-10.34-10.34-10.34ZM31.03,75.87c-1.9,0-3.45-1.54-3.45-3.45s1.54-3.45,3.45-3.45,3.45,1.54,3.45,3.45-1.54,3.45-3.45,3.45Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M65.52,62.07c-5.71,0-10.34,4.63-10.34,10.34s4.63,10.34,10.34,10.34,10.34-4.63,10.34-10.34-4.63-10.34-10.34-10.34ZM65.52,75.87c-1.9,0-3.45-1.54-3.45-3.45s1.54-3.45,3.45-3.45,3.45,1.54,3.45,3.45-1.54,3.45-3.45,3.45Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M100,82.76c5.71,0,10.34-4.63,10.34-10.34s-4.63-10.34-10.34-10.34-10.34,4.63-10.34,10.34,4.63,10.34,10.34,10.34ZM100,68.97c1.9,0,3.45,1.54,3.45,3.45s-1.54,3.45-3.45,3.45-3.45-1.54-3.45-3.45,1.54-3.45,3.45-3.45Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M31.03,89.66c-5.71,0-10.34,4.63-10.34,10.34s4.63,10.34,10.34,10.34,10.34-4.63,10.34-10.34-4.63-10.34-10.34-10.34ZM31.03,103.45c-1.9,0-3.45-1.54-3.45-3.45s1.54-3.45,3.45-3.45,3.45,1.54,3.45,3.45-1.54,3.45-3.45,3.45Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M65.52,89.66c-5.71,0-10.34,4.63-10.34,10.34s4.63,10.34,10.34,10.34,10.34-4.63,10.34-10.34-4.63-10.34-10.34-10.34ZM65.52,103.45c-1.9,0-3.45-1.54-3.45-3.45s1.54-3.45,3.45-3.45,3.45,1.54,3.45,3.45-1.54,3.45-3.45,3.45Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M31.03,117.25c-5.71,0-10.34,4.63-10.34,10.34s4.63,10.34,10.34,10.34,10.34-4.63,10.34-10.34-4.63-10.34-10.34-10.34ZM31.03,131.04c-1.9,0-3.45-1.54-3.45-3.45s1.54-3.45,3.45-3.45,3.45,1.54,3.45,3.45-1.54,3.45-3.45,3.45Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M65.52,117.25c-5.71,0-10.34,4.63-10.34,10.34s4.63,10.34,10.34,10.34,10.34-4.63,10.34-10.34-4.63-10.34-10.34-10.34ZM65.52,131.04c-1.9,0-3.45-1.54-3.45-3.45s1.54-3.45,3.45-3.45,3.45,1.54,3.45,3.45-1.54,3.45-3.45,3.45Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M141.38,93.11c-24.75.03-44.8,20.08-44.83,44.83,0,24.76,20.07,44.83,44.83,44.83s44.83-20.07,44.83-44.83-20.07-44.83-44.83-44.83ZM172.42,144.83h6.24c-3.11,16.69-16.92,29.29-33.82,30.86v-6.72c0-1.9-1.54-3.45-3.45-3.45s-3.45,1.54-3.45,3.45v6.72c-16.9-1.57-30.71-14.17-33.82-30.86h6.24c1.9,0,3.45-1.54,3.45-3.45s-1.54-3.45-3.45-3.45h-6.9c.03-19.6,14.97-35.96,34.48-37.75v6.72c0,1.9,1.54,3.45,3.45,3.45s3.45-1.54,3.45-3.45v-6.72c19.52,1.8,34.46,18.16,34.48,37.75h-6.9c-1.9,0-3.45,1.54-3.45,3.45s1.54,3.45,3.45,3.45Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M159.86,121.49l-17.74,14.79-4.77-7.15c-1.06-1.58-3.2-2.01-4.78-.96-1.58,1.06-2.01,3.2-.95,4.78l6.9,10.34c.54.81,1.41,1.36,2.37,1.5.17.03.33.04.5.04.81,0,1.59-.28,2.21-.8l20.69-17.24c1.46-1.22,1.66-3.39.44-4.86-1.22-1.46-3.39-1.67-4.86-.45Z"
  })));
};
export default SvgScheduling;